import { render, staticRenderFns } from "./norecordsComponent.vue?vue&type=template&id=7dcca1dc&scoped=true"
import script from "./norecordsComponent.vue?vue&type=script&lang=js"
export * from "./norecordsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dcca1dc",
  null
  
)

export default component.exports